import axios from "axios";
import config, { API_JAVA } from '../config';
const BASE_URL = API_JAVA;

class UserCheckService{
    
    // checkUl(captcha, captchaKey, bin, iin, type) {
    //     return axios.post(`${BASE_URL}/sdk-user/check`, {captcha, captchaKey, bin, iin, type});
    // }
    // checkFl(captcha, captchaKey, iin, type) {
    //     return axios.post(`${BASE_URL}/sdk-user/check`, {captcha, captchaKey, iin, type});
    // }
    userCheck(captcha, captchaKey, bin = null, iin, type) {
        if (bin != null && type === "ul") {
            return axios.post(`${BASE_URL}/sdk-user/check`, {captcha, captchaKey, bin, iin, type});
        } else if (iin != null && type === "fl") {
            return axios.post(`${BASE_URL}/sdk-user/check`, {captcha, captchaKey, iin, type});
        }
      
    }
}

export default new UserCheckService();
